import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { MarketdateCommentComponent } from './marketdate-comment.component';
import { MarketdateCommentDetailComponent } from './marketdate-comment-detail.component';
import { MarketdateCommentPopupComponent } from './marketdate-comment-dialog.component';
import { MarketdateCommentDeletePopupComponent } from './marketdate-comment-delete-dialog.component';

import { Principal } from '../../shared';

export const marketdateCommentRoute: Routes = [
  {
    path: 'marketdate-comment',
    component: MarketdateCommentComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateComment.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'marketdate-comment/:id',
    component: MarketdateCommentDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateComment.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const marketdateCommentPopupRoute: Routes = [
  {
    path: 'marketdate-comment-new',
    component: MarketdateCommentPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateComment.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketdate-comment/:id/edit',
    component: MarketdateCommentPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateComment.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketdate-comment/:id/delete',
    component: MarketdateCommentDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateComment.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-comment/marketdate-comment.route.ts